import { Globals } from "../CoreApp/Globals";
import type { QCanvasPanel } from "../CoreApp/QCanvasPanel";

const updateKeyboardSelection = (change: (canvasPanel: QCanvasPanel) => boolean) => {
  const wsMgr = Globals._wsMgr;
  const canvasPanel = wsMgr?.fCanvasPanel;
  if (!canvasPanel || !Globals._uiConfig.InChartKeyboardNavMode() || !change(canvasPanel)) return;

  wsMgr.PrepRenderWS();
  wsMgr.RenderWS();
};

export function handleCanvasFocus(this: HTMLCanvasElement) {
  if (!this.matches(":focus-visible")) return;

  updateKeyboardSelection(cp => cp.RestoreKeyboardSelection() || cp.SelectEntryBoxForKeyboard());
}

export function handleCanvasBlur() {
  if (document.hasFocus()) updateKeyboardSelection(cp => cp.ReleaseKeyboardSelection());
}

// A pointer selection replaces the keyboard one; later rebuilds must not bring that back.
export function handleCanvasPointerDown() {
  Globals._wsMgr?.fCanvasPanel?.ForgetKeyboardSelection();
}
